export const SELECT_EXPAND_ICON_NAME = 'expand_more';
export const SELECT_COLLAPSE_ICON_NAME = 'expand_less';

export const SELECT_EXPAND_ATTRIBUTE = 'expanded';

export const SELECT_TOGGLE_ICON_QUERY = 'section > span[aria-owns]';
export const SELECT_TOGGLE_ICON_IDENTIFIER = 'toggle';

export const SELECT_ITEMS_CONTAINER_QUERY = 'ul';
export const SELECT_ITEMS_CONTAINER_IDENTIFIER = 'items container';

export const SELECT_INPUT_QUERY = 'section > section > input';
export const SELECT_INPUT_IDENTIFIER = 'select input';


export const SELECT_ITEMS_QUERY = 'ul > li';
export const SELECT_ITEMS_IDENTIFIER = 'items';
